import React from "react";

const words = [
  "COMPRA",
  "VENDE",
  "CONECTA",
  "SIN INTERMEDIARIOS",
  "24/7",
  "DIRECTO POR WHATSAPP",
];

export const EditorialMarquee: React.FC = () => {
  const track = [...words, ...words];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative bg-motor-ink py-4 sm:py-5 overflow-hidden border-y border-white/10"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee motion-reduce:animate-none">
        {track.map((word, i) => (
          <span
            key={i}
            className="font-display font-semibold text-sm sm:text-base tracking-[0.2em] text-white/70 mx-6 flex items-center gap-6"
          >
            {word}
            <span className="text-motor-red">•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
